import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/app.hooks';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { IApiColMappingProps } from './apiColMapping.model';
import MainTable from './MainTable';
import { Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import DeleteDatasetModal from '../../../common/components/DeleteDatasetModal';
import {
  apiColumnMappingSelector,
  clearApiColMapping,
} from '../../../store/sps/apiColumnMapping/apiColMapping.reducer';

const APIColumnMappings: React.FC<IApiColMappingProps> = () => {
  const apiColMap = useAppSelector(apiColumnMappingSelector);
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();

  const [deleteModalVisible, setDeleteModalVisible] = React.useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearApiColMapping());
    };
  }, []);

  const refreshDataTable = () => {
    dataTableRef?.current.refreshData();
  };

  return (
    <div className="sqlServer">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.ConfigSPSColMapping} />
        </h4>
        {/* <div className="right-title">
          <GlobalSearch />
        </div> */}
      </div>
      <div className="main-card">
        <MainTable
          ref={dataTableRef}
          setSelectedId={(id) => {
            id === 0
              ? history.push('/administration/config-sps-api-column-mapping/add')
              : history.push(`/administration/config-sps-api-column-mapping/add/${id}`);
          }}
        />
      </div>
      {deleteModalVisible && (
        <DeleteDatasetModal
          showModal={deleteModalVisible}
          handleModalClose={() => setDeleteModalVisible(false)}
          tableName={apiColMap.search.tableName}
          refreshDataTable={() => refreshDataTable()}
        />
      )}
    </div>
  );
};

export default APIColumnMappings;
